import { clearSpace } from './clear-number';

export const securityCheck = (value) => {
  if (!value || typeof value !== 'string') return false;
  if (clearSpace(value).indexOf('<script') !== -1) return true;
};
